import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { TrainingCourseClassApiModel, TrainingCourseClassSelectorsApiModel } from '@app/api/api-models';
import { HttpClientService } from '@app/api/api-services/http-client.service';

@Injectable()
export class TrainingCourseClassesService {
  public apiUrl = 'training-course-classes';

  constructor(private readonly http: HttpClientService) {}

  public getById(id: number): Observable<TrainingCourseClassApiModel> {
    return this.http.get<TrainingCourseClassApiModel>(`${this.apiUrl}/${id}`);
  }

  public getSelectorsById(id: number): Observable<TrainingCourseClassSelectorsApiModel> {
    return this.http.get<TrainingCourseClassSelectorsApiModel>(`${this.apiUrl}/${id}/selectors`);
  }

  public add(model: TrainingCourseClassApiModel): Observable<TrainingCourseClassApiModel> {
    return this.http.post<TrainingCourseClassApiModel>(`${this.apiUrl}`, model);
  }

  public update(model: TrainingCourseClassApiModel): Observable<TrainingCourseClassApiModel> {
    return this.http.put<TrainingCourseClassApiModel>(`${this.apiUrl}`, model);
  }

  public delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }

  public complete(id: number): Observable<void> {
    return this.http.put<void>(`${this.apiUrl}/${id}/complete`, null);
  }
}
